var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersArrowReversed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6411 7.76908C11.4369 7.93784 11.1744 8.01909 10.9106 7.99513C10.6468 7.97117 10.4031 7.84393 10.2327 7.64114L6.00013 2.56273L1.76746 7.64106C1.59755 7.84465 1.35372 7.97239 1.08962 7.9962C0.825512 8.02001 0.562768 7.93793 0.359184 7.76802C0.155599 7.59811 0.0278505 7.35428 0.00404118 7.09018C-0.0197681 6.82607 0.0623122 6.56333 0.232225 6.35974L5.23251 0.359483C5.32631 0.246995 5.44369 0.156498 5.57634 0.0943956C5.70898 0.0322928 5.85366 0.000102997 6.00013 0.000102997C6.14659 0.000102997 6.29127 0.0322928 6.42391 0.0943956C6.55656 0.156498 6.67394 0.246995 6.76774 0.359483L11.768 6.35983C11.9379 6.56362 12.0199 6.82649 11.9961 7.09072C11.9723 7.35494 11.8446 7.59892 11.6411 7.76908Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersArrowReversed);
export default __webpack_public_path__ + "static/media/OrdersArrowReversed.2387e2ed5f338019d6cd5c0302504d91.svg";
export { ForwardRef as ReactComponent };